import { useEffect, useRef } from 'react'

import useDispatch from 'hooks/useDispatch'
import useReduxSelector from 'hooks/useReduxSelector'
import { setNavbarSticky } from 'actions/navbarActions'

const useStickyNavbar = (sticky: boolean) => {
  const dispatch = useDispatch()
  const currentStateValue = useReduxSelector((state) => state?.navbar?.sticky)
  const initialValue = useRef(currentStateValue)

  const setNew = () => {
    dispatch(setNavbarSticky(sticky))
  }

  const restoreInitial = () => {
    dispatch(setNavbarSticky(initialValue.current))
  }

  useEffect(() => {
    setNew()

    return restoreInitial
  }, [])
}

export default useStickyNavbar
